import { useMemo } from 'react'

import { AuthStorageRepository } from './auth-storage.repository'
import { AuthService } from './auth.service'

export const useAuth = () => {
  const service = useMemo(() => {
    const authStorageRepository = AuthStorageRepository.getInstance()
    const authService = AuthService.getInstance(authStorageRepository)
    return authService
  }, [])
  return service
}
